import React from "react";
import DesignerCard from "../designer-card/DesignerCard";
import { Profile } from "@/hooks/designer-grid/types";
import { DISCIPLINES } from "@/data/constants";

interface ProfileCardProps {
  profile: Profile;
  className?: string; // Add className prop for potential use
}

const ProfileCard = ({ profile, className = '' }: ProfileCardProps) => {
  // Default placeholder image
  const placeholderImage =
    "/lovable-uploads/06a7565c-628b-47f8-84c3-657eb3f0f9d6.png";

  // Function to properly format profession title with appropriate capitalization
  const formatProfessionTitle = (profession: string): string => {
    if (!profession) return "";

    // Split by spaces and capitalize each word
    return profession
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };
  const getDisciplineLabel = (str: string) => {
    const discipline = DISCIPLINES.find((d) => d.id === str);
    if (discipline) {
      return discipline.label;
    } else {
      return str.split("-").join(" ");
    }
  };

  // Use profile.display_name with fallback to username or 'Anonymous Designer'
  const displayName =
    profile.display_name || profile.username || "Anonymous Designer";

  // Use profession directly without any transformation to ensure consistency
  const displayTitle =
    profile.profession ||
    (profile.skills && profile.skills.length > 0
      ? getDisciplineLabel(profile.skills[0])
      : "Designer");

  // Capitalize location - replace dashes with spaces first
  const location = profile.location
    ? profile.location
        .replace(/-/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
    : "Africa";

  return (
    <DesignerCard
      id={profile.id}
      name={displayName}
      title={displayTitle}
      location={location}
      imageSrc={profile.avatar_url || placeholderImage}
      viewCount={profile.view_count || 0}
      likeCount={profile.like_count || 0}
      isLiked={profile.is_liked || false}
      skills={profile.skills || []}
      username_slug={profile.username_slug}
      className={className}
      hire_me_enabled={profile.hire_me_enabled}
      is_featured={profile.is_featured || false}
    />
  );
};

export default ProfileCard;
